<template>

  <div id="app" :dark="getDarkSide" :style="`font-family:${getFonts.principal}`" :client="getClient" :route="$route.name" v-if="true">

    <app-header v-if="getLogged"></app-header>

    <div class="wrapper" :has-menu="getLogged">

      <router-view />

    </div>

    <app-footer></app-footer>

    <error-banner></error-banner>

    <template v-if="!getGodmodeStatus">

      <encuestas-obligatorias v-if="showEncuestas"></encuestas-obligatorias>
      
      <rellenar-datos-personales v-if="$route.name != 'cv' && getBrand.popupDatosObligatorios && isAlumno"></rellenar-datos-personales>
      
      <faltan-datos-empresa v-if="showRequestDatosEmpresa"></faltan-datos-empresa>
    </template>

  </div>

  <div id="" v-else style="background-color: #2581C4; text-align: center; padding: 150px; font: 20px Helvetica, sans-serif; color: #fff; height: 100%;">
    <img id="img360" src="data:image/png;base64,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">
    <h1 style="font-size: 50px;">Lo sentimos, estamos inactivos por mantenimiento.</h1>
    <h2 style="line-height: 3;">Estaremos de vuelta pronto.</h2>
  </div>

</template>

<script>

  require('waypoints/lib/noframework.waypoints.js')

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'
  import loading from '@/components/parts/loading'
  import errorBanner from '@/components/parts/error-banner'

  import encuestasObligatorias from '@/components/parts/encuestas-obligatorias'
  import rellenardatospersonales from '@/components/parts/popup-rellenar-datos-personales'
  import popupFaltanDatosEmpresa from '@/components/parts/popup-faltan-datos-empresa'

  

  import router from '@/router'

  import CookieLaw from 'vue-cookie-law'

  import { mapGetters, mapActions } from 'vuex';

  var jwt_decode = require('jwt-decode');

  export default {
    name: 'App',
    components: {
      'app-header': header,
      'app-footer': footer,
      'loading': loading,
      'cookie-law': CookieLaw,
      'error-banner': errorBanner,
      'encuestas-obligatorias': encuestasObligatorias,
      'rellenar-datos-personales' : rellenardatospersonales,
      'faltan-datos-empresa' : popupFaltanDatosEmpresa
    },
    mounted() {
      this.checkSesion()

      if(this.getDarkSide){
        document.getElementsByTagName("body")[0].classList.add("dark");
      }

    },
    computed: {
      ...mapGetters([
        'getLogged',
        'getDarkSide',
        'getErrorCode',
        'basicColors',
        'getEncuestasObligatorias',
        'getFonts',
        'getFooterLinks',
        'getClient',
        'getBrand',
        'isAlumno',
        'isEmpresa',
        'getGodmodeStatus'
      ]),
      styleWrapper: function () {
        return {
          background: this.basicColors.white,
          color: this.basicColors.dark_black
        }
      },
      showEncuestas: function () {
        let show = (this.getEncuestasObligatorias.length > 0 & this.$route.name != 'ficha_encuestas' & !!this.getLogged);
        return (show == 1) ? true : false;
      },
      showRequestDatosEmpresa(){
        let show = true;

        let notshowin = ['mi_perfil','mi empresa'];

        if(notshowin.some(e => this.$route.name == e)){
          show = false;
        }

        return (show && this.getBrand.checkDatosCompletosEmpresa);

      }
    },
    methods: {
      ...mapActions(['requestAllData', 'setError']),
      checkSesion() {

        if (!!window.localStorage.getItem('_token')) {

          let tokendecoded = jwt_decode(window.localStorage.getItem('_token'));
          let actual = new Date().getTime() / 1000;

          if (actual > tokendecoded.exp) {

            this.setError(2);

          } else {

            if (this.getLogged && this.$route.name != 'ficha_encuestas') {
              this.requestAllData();
            }

          }


        }else{

          if (!!!this.getLogged && this.$route.meta.requiresAuth) {
            router.push('/login');
          }

        }

      }
    }
  }
</script>

<style lang="scss">
  @import "@/assets/css/colors.scss";
  @import "./assets/css/style.scss";
  @import './assets/css/slick.css';
  @import "@/assets/css/brands.scss";
  @import "vue-multiselect/dist/vue-multiselect.min.css";
  @import url('https://fonts.googleapis.com/css?family=Lato:300,400,500,600,700,800,900|Nunito:400,700,900');
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
  @import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);

  html, body { height: 100%; }
  #img360 {
    border-radius: 100px;
    margin-left: 0px;
    -webkit-animation:spinMantenimiento 4s linear infinite;
    -moz-animation:spinMantenimiento 4s linear infinite;
    animation:spinMantenimiento 4s linear infinite;
  }
  @-moz-keyframes spinMantenimiento { 100% { -moz-transform: rotate(360deg); } }
  @-webkit-keyframes spinMantenimiento { 100% { -webkit-transform: rotate(360deg); } }
  @keyframes spinMantenimiento { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

</style>


// WEBPACK FOOTER //
// src/App.vue